module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Food/Chicken-5acd9cb7511002ff7043ce0866fb8d3a5f5559fc5c3c6456398bca0ccc5e4365.svg";